import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteRegista, useRegista, useUpdateRegista } from '../../hooks/registi'
import { Regista } from '../../types'
import RegistaForm from '../../components/RegistaForm'

export default function RegistaEdit() {
  const { id } = useParams()
  const { data: regista } = useRegista(Number(id!))
  const deleteRegista = useDeleteRegista()
  const updateRegista = useUpdateRegista()
  const [modalRm, modalRmActions] = useModalTrigger<Regista>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/registi">Registi</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {regista?.nome}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(regista)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <RegistaForm
          regista={regista}
          save={(regista) =>
            updateRegista.mutateAsync(regista).then(() =>
              toast.success('Regista salvato con successo!', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il regista {modalRm.value.nome} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteRegista.isLoading}
            onClick={async () => {
              await deleteRegista.mutateAsync(modalRm.value!.id)
              navigate('/registi')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
